import { render, staticRenderFns } from "./PeopleRanking.vue?vue&type=template&id=50349d1b&scoped=true&"
import script from "./PeopleRanking.vue?vue&type=script&lang=js&"
export * from "./PeopleRanking.vue?vue&type=script&lang=js&"
import style0 from "./PeopleRanking.vue?vue&type=style&index=0&id=50349d1b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50349d1b",
  null
  
)

export default component.exports